export const MAIL_TEMPLATE = {
    FINISH:"SRRF",
    REJECT:"SRRR",
    APPROVE:"SRRA"
}